export default "__VITE_PUBLIC_ASSET__c17b2c8c__"